export default function Clock_Face() {
  return (
    <div>
      <h1>Clock_Face Component</h1>
    </div>
  );
}
